module.exports = __webpack_public_path__ + "assets/0fc438b1b47687da2a1a08c9de25f4b5.png";